export default {
  searchDate: 0,
  mediaTypes: {
    feed: {
      description: "Você está pesquisando todos tipos de mídia",
      icon: "mdi-rss",
      types: undefined,
      route: "feed",
    },
    alerta: {
      description: "Você está pesquisando alerta",
      icon: "mdi-bell-ring-outline",
      types: ["alert"],
      route: "alerta",
    },
    noticia: {
      description: "Você está pesquisando notícia",
      icon: "mdi-newspaper",
      types: ["news"],
      route: "noticia",
    },
    estudo: {
      description: "Você está pesquisando estudo",
      icon: "mdi-chart-areaspline",
      types: ["study"],
      route: "estudo",
    },
    comunicacao: {
      description: "Você está pesquisando comunicação",
      icon: "mdi-folder-multiple-image",
      types: ["comunication"],
      route: "comunicacao",
    },
    socials: {
      description: "Você está pesquisando redes sociais",
      icon: "mdi-television-play",
      types: ["social-network"],
      route: "socials",
    },
    uao: {
      description: "Você está pesquisando UAO",
      icon: "mdi-television-play",
      types: ["uao"],
      route: "uao",
    },
    rss: {
      description: "Você está pesquisando RSS",
      icon: "mdi-rss",
      types: ["rss"],
      route: "rss",
    },
    relatorio: {
      description: "Você está pesquisando relatório",
      icon: "mdi-file-document-outline",
      types: ["report"],
      route: "report",
    },
    "alerta-noticia": {
      description: "Você está procurando alertas e noticias",
      icon: "mdi-rss",
      types: ["alert", "news"],
      route: "alerta-noticia",
    },
    "*": {
      description: "Você está pesquisando todos os tipos de mídias",
      icon: "mdi-rss",
      types: ["*"],
      route: "*",
    },
  },
};
